import { ReducerBuilder } from './reducerBuilder';
import { AppVersionState } from 'acscp/store';
import {
    AppResumed,
    DismissUpdateRecommendations,
    ForceUpdate,
    IgnoreUpdateRecommendations,
    RecommendUpdate, ResetForcedUpdate
} from 'acscp/actions';

export const appVersionReducer =
    new ReducerBuilder<AppVersionState>({
        forceUpdate: false,
        versionRecommendations: {}
    })
    .actionCase(ForceUpdate, (state, action) => ({
        ...state,
        forceUpdate: true,
    }))
    .actionCase(ResetForcedUpdate, (state, action) => ({
        ...state,
        forceUpdate: false,
    }))
    .actionCase(AppResumed, (state, action) => ({
        ...state,
        forceUpdate: false,
    }))
    .actionCase(RecommendUpdate, (state, action) => ({
        ...state,
        versionRecommendations: {
            ...state.versionRecommendations,
            // Don't re-recommend a version if the user ignored it before
            [action.version]: state.versionRecommendations[action.version] || {recommendationIgnored: false}
        }
    }))
    .actionCase(DismissUpdateRecommendations, (state, action) => {
        const newState: AppVersionState = {
            ...state,
            versionRecommendations: {}
        };

        // Only copy over ignored versions.
        // Recommendations for any other version are wiped - API should re-recommend if necessary.
        Object.keys(state.versionRecommendations)
            .filter(version => state.versionRecommendations[version].recommendationIgnored)
            .forEach(version => newState.versionRecommendations[version] = {recommendationIgnored: true});

        return newState;
    })
    .actionCase(IgnoreUpdateRecommendations, (state, action) => {
        const newState: AppVersionState = {
            ...state,
            versionRecommendations: {}
        };

        // Ignore all known versions
        Object.keys(state.versionRecommendations)
            .forEach(version => newState.versionRecommendations[version] = {recommendationIgnored: true});

        return newState;
    })
    .build();
